import React from 'react';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
 const { t } = useTranslation();

 return (
 <section className="relative bg-cream-50 border-b border-ink-200">
 <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-20 lg:pt-32 lg:pb-24">
 <div className="text-center">
 <h1 className="font-serif text-ink-900 text-5xl md:text-6xl lg:text-7xl leading-[1.05] mb-8 tracking-tight">
 {t('homepage.hero.title')}
 </h1>

 <p className="text-lg md:text-xl text-ink-600 font-normal max-w-2xl mx-auto leading-relaxed">
 {t('homepage.hero.subtitle')}
 </p>
 </div>
 </div>
 </section>
 );
}
